import App from '@/app'

App.directive('lazy-image', function(el) {
	const link = document.createElement('link')

	link.href = el.src;
	link.rel  = 'preload'
	link.as   = 'image'


	document.head.appendChild(link)
})
